import { Collection, type ApiResponse, type CollectionSortState, type FetchOptions } from 'core/model/Collection';
import safelyParseJSON from '@kentik/ui-shared/util/safelyParseJson';
import SuppressionModel, { type SuppressionAttributes } from './SuppressionModel';

const FETCH_LIMIT = 10000;

// legacy (`testID`) and synth agent maintenance-mode suppressions are managed from agent details
function isSystemManaged(suppression: Partial<SuppressionAttributes>) {
  const metadata = safelyParseJSON(suppression.application_metadata || '') as
    | { testID?: unknown; isAgentSuppression?: unknown }
    | undefined;
  const { testID, isAgentSuppression } = metadata || {};

  return Boolean(isAgentSuppression || testID);
}

export default class SuppressionCollection extends Collection<SuppressionModel> {
  get url() {
    return '/api/ui/alertingManager/suppressions';
  }

  get urlPaths() {
    return { fetch: `${this.url}/list` };
  }

  protected get fetchMethod(): 'post' {
    return 'post';
  }

  get jsonRoot() {
    return 'suppressions';
  }

  get model() {
    return SuppressionModel;
  }

  protected get defaultSortState(): CollectionSortState<SuppressionModel> {
    return {
      field: 'cdate',
      direction: 'desc'
    };
  }

  fetch(options: FetchOptions<SuppressionModel> = {}) {
    return super.fetch({ ...options, data: { pagination: { limit: FETCH_LIMIT, offset: 0 } } });
  }

  deserialize(data: ApiResponse<SuppressionModel>) {
    return (super.deserialize(data) || []).filter((suppression) => !isSystemManaged(suppression));
  }
}
